import { DatePipe } from '@angular/common';
import { Ui2DatePickerModel } from '../models/date-picker.model';

const format = 'MMM d, y';

export const buildSingleDateObject = (date: Date, datePipe: DatePipe): Ui2DatePickerModel => ({
  date: {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  },
  jsdate: date,
  beginJsDate: date,
  formatted: datePipe.transform(date, format)
});

export const buildRangeDateObject = (start: Date, end: Date, datePipe: DatePipe): Ui2DatePickerModel => ({
  beginDate: {
    year: start.getFullYear(),
    month: start.getMonth() + 1,
    day: start.getDate()
  },
  beginJsDate: start,
  endDate: {
    year: end.getFullYear(),
    month: end.getMonth() + 1,
    day: end.getDate()
  },
  endJsDate: end,
  formatted: `${datePipe.transform(start, format)} - ${datePipe.transform(end, format)}`,
  beginEpoc: start.getTime(),
  endEpoc: end.getTime()
});
